import React from "react";

export const TransitionContext = React.createContext();